var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-wrap"},[_vm._m(0),_vm._v(" "),_c('tip-tabs'),_vm._v(" "),_c('chat-list'),_vm._v(" "),_c('send-box'),_vm._v(" "),_c('relevant-list'),_vm._v(" "),_c('back-top')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-box"},[_c('img',{attrs:{"src":require("@/assets/image/banner@3x.png"),"alt":""}})])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eceb312","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = null
// module chunks = 